module.exports = __webpack_public_path__ + "img/Infografis_ID_13.9c977bf8.jpg";